/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { UpdateMerchantStyleDto } from '../models/update-merchant-style-dto';

@Injectable({
  providedIn: 'root',
})
export class MerchantStyleService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation merchantStyleMergedCreditCardHtml
   */
  static readonly MerchantStyleMergedCreditCardHtmlPath = '/api/merchant-style/merged-credit-card-html';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `merchantStyleMergedCreditCardHtml()` instead.
   *
   * This method doesn't expect any request body.
   */
  merchantStyleMergedCreditCardHtml$Response(params?: {
    cssStyle?: string;
  }): Observable<StrictHttpResponse<string>> {

    const rb = new RequestBuilder(this.rootUrl, MerchantStyleService.MerchantStyleMergedCreditCardHtmlPath, 'post');
    if (params) {
      rb.query('cssStyle', params.cssStyle, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<string>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `merchantStyleMergedCreditCardHtml$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  merchantStyleMergedCreditCardHtml(params?: {
    cssStyle?: string;
  }): Observable<string> {

    return this.merchantStyleMergedCreditCardHtml$Response(params).pipe(
      map((r: StrictHttpResponse<string>) => r.body as string)
    );
  }

  /**
   * Path part for operation merchantStylePutCreditCardSettings
   */
  static readonly MerchantStylePutCreditCardSettingsPath = '/api/merchant-style/put-credit-card-settings';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `merchantStylePutCreditCardSettings()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  merchantStylePutCreditCardSettings$Response(params: {
    body: UpdateMerchantStyleDto
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, MerchantStyleService.MerchantStylePutCreditCardSettingsPath, 'put');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `merchantStylePutCreditCardSettings$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  merchantStylePutCreditCardSettings(params: {
    body: UpdateMerchantStyleDto
  }): Observable<void> {

    return this.merchantStylePutCreditCardSettings$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation merchantStyleGetCreditCardSettings
   */
  static readonly MerchantStyleGetCreditCardSettingsPath = '/api/merchant-style/get-credit-card-settings';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `merchantStyleGetCreditCardSettings()` instead.
   *
   * This method doesn't expect any request body.
   */
  merchantStyleGetCreditCardSettings$Response(params?: {
  }): Observable<StrictHttpResponse<string>> {

    const rb = new RequestBuilder(this.rootUrl, MerchantStyleService.MerchantStyleGetCreditCardSettingsPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<string>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `merchantStyleGetCreditCardSettings$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  merchantStyleGetCreditCardSettings(params?: {
  }): Observable<string> {

    return this.merchantStyleGetCreditCardSettings$Response(params).pipe(
      map((r: StrictHttpResponse<string>) => r.body as string)
    );
  }

}
